import CryptoJS from "crypto-js";

const secretKey = CryptoJS.enc.Hex.parse(
  "b1e5efb7397cd9778b2a47bcdf806b9f7e3590c00395ac88c340021a5ab41bca"
); // Same secret key used in Node.js
const iv = CryptoJS.enc.Hex.parse("40415b63f337db62c26def4303e03e82");
export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  return encrypted;
}

export function decrypt(encryptedText) {
  const decrypted = CryptoJS.AES.decrypt(encryptedText, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
  return decrypted;
}
